import { useState, useEffect } from 'react'
import { apiService } from '../services/api'

interface ConfigurationState {
  isValid: boolean
  isLoading: boolean
  config: {
    baseUrl: string
    region: string
    environment: 'development' | 'production'
  }
  error: {
    code: string
    message: string
    details?: any
    retryable: boolean
  } | null
  isDevelopmentMode: boolean
  isUsingPlaceholder: boolean
}

export function useConfiguration(): ConfigurationState {
  const [state, setState] = useState<ConfigurationState>(() => {
    const config = apiService.getConfiguration()
    const isValid = apiService.isConfigurationValid()
    const error = apiService.getConfigurationError()
    
    return {
      isValid,
      isLoading: false,
      config,
      error: error?.error || null,
      isDevelopmentMode: config.environment === 'development',
      isUsingPlaceholder: config.baseUrl === 'https://api.example.com'
    }
  })

  useEffect(() => {
    // Re-check configuration periodically in case environment variables change
    const checkConfiguration = () => {
      const config = apiService.getConfiguration()
      const isValid = apiService.isConfigurationValid()
      const error = apiService.getConfigurationError()
      
      setState({
        isValid,
        isLoading: false,
        config,
        error: error?.error || null,
        isDevelopmentMode: config.environment === 'development',
        isUsingPlaceholder: config.baseUrl === 'https://api.example.com'
      })
    }

    // Check immediately
    checkConfiguration()

    // Set up periodic checks (every 30 seconds)
    const interval = setInterval(checkConfiguration, 30000)

    return () => clearInterval(interval)
  }, [])

  return state
}

export default useConfiguration